import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Legal() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://auralisconsulting.io';
  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Legal Notice",
    "description": "Legal Notice of Auralis Consulting - Legal and regulatory information",
    "url": `${siteUrl}/legal`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "Auralis Consulting",
      "url": siteUrl
    },
    "about": {
      "@type": "Thing",
      "name": "Legal Notice"
    },
    "datePublished": "2024-01-01",
    "dateModified": new Date().toISOString().split('T')[0]
  };

  return (
    <>
      <SEOHead
        title="Legal Notice - Auralis Consulting"
        description="Legal Notice of Auralis Consulting - Legal and regulatory information concerning our business strategy consulting company."
        canonical={`${siteUrl}/legal`}
        ogType="article"
        schemaData={schemaData}
      />
      <div className="min-h-screen bg-white">
        <Navigation />
        <div className="pt-24 pb-16">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
              Legal Notice
            </h1>
            <p className="text-gray-600 mb-12">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Company Information</h2>
                <div className="bg-gray-50 p-6 rounded-lg space-y-2">
                  <p><strong>Company Name:</strong> Auralis Consulting</p>
                  <p><strong>Trade License Number:</strong> 47025742</p>
                  <p><strong>Registered Office:</strong></p>
                  <p className="pl-4">
                    Compass Building Al Shohada Road<br />
                    AL Hamra Industrial Zone-FZ<br />
                    Ras Al Khaimah<br />
                    United Arab Emirates
                  </p>
                  <p><strong>Phone:</strong> +971 56 718 2619</p>
                  <p><strong>Email:</strong> auralisconsult<span style={{display: 'none'}}>null</span>@<span style={{display: 'none'}}>null</span>gmail.com</p>
                  <p><strong>Website:</strong> https://auralisconsulting.io</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Publication Director</h2>
                <p>
                  The publication director of the website auralisconsulting.io is the legal representative of Auralis Consulting.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Website Hosting</h2>
                <p className="mb-3">The website auralisconsulting.io is hosted by:</p>
                <div className="bg-gray-50 p-6 rounded-lg space-y-2">
                  <p><strong>Host:</strong> Readdy.ai</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
                <p className="mb-3">
                  All content on this website (texts, images, videos, logos, graphics, etc.) is the exclusive property of Auralis Consulting, unless otherwise stated.
                </p>
                <p className="mb-3">
                  Any reproduction, distribution, modification, adaptation, retransmission or publication of these elements is strictly prohibited without the prior written consent of Auralis Consulting.
                </p>
                <p>
                  The trademarks, logos and distinctive signs reproduced on this website are the property of Auralis Consulting or third parties who have authorized their use.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Personal Data Protection</h2>
                <p className="mb-3">
                  Auralis Consulting is committed to protecting the privacy of its users and processing their personal data in accordance with applicable regulations, including the General Data Protection Regulation (GDPR).
                </p>
                <p>
                  For more information on the collection and processing of your personal data, please consult our <a href="/privacy-policy" className="text-blue-600 hover:text-blue-800 underline cursor-pointer">Privacy Policy</a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cookies</h2>
                <p className="mb-3">
                  This website uses cookies to improve user experience and analyze traffic. Cookies are small text files stored on your device when you visit our website.
                </p>
                <p className="mb-3">
                  You can configure your browser to refuse cookies or be notified when a cookie is placed. However, some features of the website may not function properly without cookies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Liability</h2>
                <p className="mb-3">
                  Auralis Consulting strives to provide information as accurate as possible on this website. However, we cannot guarantee the accuracy, completeness or timeliness of the information provided.
                </p>
                <p className="mb-3">
                  Auralis Consulting cannot be held responsible for direct or indirect damages resulting from access to the website or use thereof, including inaccessibility, data loss, deterioration, destruction or viruses that could affect your computer equipment.
                </p>
                <p>
                  The user is solely responsible for the use they make of the information and content present on the website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Hyperlinks</h2>
                <p className="mb-3">
                  This website may contain links to other websites. Auralis Consulting exercises no control over these websites and disclaims all responsibility for their content.
                </p>
                <p>
                  The creation of hyperlinks to the website auralisconsulting.io requires the prior written authorization of Auralis Consulting.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Applicable Law and Jurisdiction</h2>
                <p className="mb-3">
                  This legal notice is governed by the laws of the United Arab Emirates.
                </p>
                <p>
                  In the event of a dispute and in the absence of an amicable agreement, the dispute shall be brought before the competent courts of Ras Al Khaimah, United Arab Emirates.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Modification of Legal Notice</h2>
                <p>
                  Auralis Consulting reserves the right to modify this legal notice at any time. Users are invited to consult it regularly to be aware of any changes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact</h2>
                <p className="mb-3">
                  For any questions regarding this legal notice, you can contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="mb-2"><strong>Auralis Consulting</strong></p>
                  <p className="mb-2">Compass Building Al Shohada Road</p>
                  <p className="mb-2">AL Hamra Industrial Zone-FZ</p>
                  <p className="mb-2">Ras Al Khaimah, United Arab Emirates</p>
                  <p className="mb-2">Email: auralisconsult<span style={{display: 'none'}}>null</span>@<span style={{display: 'none'}}>null</span>gmail.com</p>
                  <p>Phone: +971 56 718 2619</p>
                </div>
              </section>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
